import { useMutation } from '@tanstack/react-query';

// services
import API from '../../services/api';

import { queryClient } from '../../AppComposer';
import messageContentQueryKeys from '../message-content/_queryKey';
import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';
import formulaKeys from './_queryKeys';

export default function useDatasetFiltersMutation(formulaId: number) {
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);
    return useMutation({
        mutationFn: API.updateDatasetFilters,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessageCountUpdate(formulaId),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaById(formulaId),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessages(
                    formulaId,
                    currentMessageContentId,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: messageContentQueryKeys.messageContent(
                    currentMessageContentId!,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
        },
    });
}
